import { ThemeEnum } from 'ui/src/components/Theme';
import ButtonUI from 'ui/src/components/Button';

const Button = ButtonUI<ThemeEnum.Site>;

export default Button;
